<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5
        class="modal-title"
        id="KBSEditModalLabel"
      >Edit Kanban Setup</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <form id="formEditKBSetup">
        <div class="row">
          <div class="col-sm-2">
            <label style="font-weight: bold;">Aisin</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="aisin"
              :disabled="true"
            />
          </div>
          <div class="col-sm-2">
            <label style="font-weight: bold;">Read</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="read"
              :disabled="true"
            />
          </div>
          <div class="col-sm-2">
            <label style="font-weight: bold;">Ordered</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="ordered"
              :disabled="true"
            />
          </div>
          <div class="col-sm-2">
            <label style="font-weight: bold;">Total (Current)</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="current"
              :disabled="true"
            />
          </div>
          <div class="col-sm-2">
            <label style="font-weight: bold;">Setup</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="setup"
            />
          </div>
          <div class="col-sm-2 d-flex align-items-center flex-column">
            <button
              type="button"
              class="btn btn-info btn-fix w-100 mb-2"
              id="act_btn"
              @click="checkForm"
              :disabled="parseInt(this.md_data.setup) === parseInt(this.setup)"
            ><i class="fas fa-save"></i> Save</button>
            <button
              type="button"
              class="btn btn-secondary btn-fix w-100"
              data-bs-dismiss="modal"
              id="KBSEditModalclose"
            ><i class="fa fa-times"></i> Close</button>
          </div>
        </div>
      </form>
      <hr class="mt-1 mb-1">
      <div class="table-responsive tableFixHead">
        <table class="table customize-table mb-0 v-middle">
          <thead class="table-light">
            <tr>
              <th class="border-bottom border-top text-center">No</th>
              <th class="border-bottom border-top text-center">Create</th>
              <th class="border-bottom border-top text-end">Kanban Current Setup</th>
              <th class="border-bottom border-top text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="text-center"
                colspan="4"
                v-if="isLoad == true"
              ><i class="fas fa-sync-alt fa-spin fa-2x fa-fw"></i></td>
            </tr>
            <tr v-if="result_data.pagination.length < 1 && isLoad == false">
              <td
                class="text-center"
                colspan="4"
              >No Data</td>
            </tr>
            <tr
              v-for="(rs, i) in result_data.pagination"
              :key="'rs' + i"
            >
              <td class="text-center">{{ per_page * active_page - (per_page - i) + 1 }}</td>
              <td class="text-center">
                {{ dateFormatAndFulltime(rs.psu_create) }}
              </td>
              <td class="text-end">
                {{ rs.psu_kanban_current }}
              </td>
              <td class="text-center">
                <span
                  class="badge rounded-pill font-weight-medium bg-light-success text-success"
                  v-if="parseInt(rs.psu_active) === 1"
                >Active</span>
                <span
                  class="badge rounded-pill font-weight-medium bg-light-danger text-danger"
                  v-if="parseInt(rs.psu_active) === 0"
                >Expired</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="text-end mt-3"
        v-if="parseInt(result_data.count) > parseInt(per_page) && isLoad == false"
      >
        <a-pagination
          style="cursor: pointer;"
          v-model="active_page"
          :pageSize.sync="per_page"
          :total="result_data.count"
          :itemRender="itemRender"
          @change="activePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import api from '../../models/kanbansuffix'

export default {
  props: ['md_data', 'search'],
  data () {
    return {
      aisin: 0,
      read: 0,
      ordered: 0,
      current: 0,
      setup: 0,
      active_page: 1,
      per_page: 10,
      isLoad: false,
      result_data: {
        pagination: [],
        count: 0
      }
    }
  },
  mounted () {
    var myModalEl = document.getElementById('KBSEditModal')
    myModalEl.addEventListener('shown.bs.modal', event => {
      this.getHistory()
      this.aisin = this.md_data.aisin
      this.read = this.md_data.read
      this.ordered = this.md_data.ordered
      this.current = this.md_data.current
      this.setup = this.md_data.setup
      // eslint-disable-next-line no-undef
      $('#formEditKBSetup').removeClass('was-validated')
    })
  },
  methods: {
    checkForm () {
      var $myForm = $('#formEditKBSetup')
      if (!$myForm[0].checkValidity()) {
        $('#formEditKBSetup').addClass('was-validated')
      } else {
        this.updateKBSetup()
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage (value) {
      this.active_page = value
      this.getHistory()
    },
    getHistory () {
      this.isLoad = true
      var obj = {
        ps_id: this.md_data.ps_id,
        page: this.active_page,
        limit: this.per_page
      }
      this.result_data.pagination = []
      this.result_data.count = 0
      this.header.params = obj
      api.getKanbanSetupHistory(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'Get Kanban Setup History', result.message)
          }
          this.isLoad = false
        },
        (error) => {
          this.alert_msg('error', 'Get Kanban Setup History', error.message)
          this.isLoad = false
        }
      )
    },
    updateKBSetup () {
      Swal.fire({
        title: 'Change Kanban Setup',
        text: 'You are changing Kanban Setup from ' + this.md_data.setup + ' to ' + this.setup + '. Want to continue ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#26AD0B',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then(result => {
        if (result.isConfirmed) {
          $('.preloader').fadeIn()
          $('#KBSEditModalclose').click()
          const obj = {
            ps_id: this.md_data.ps_id,
            new_current: this.setup
          }
          api.updateKanbanSetup(
            this.$store.state.URLHost,
            obj,
            this.header,
            result => {
              if (result.response === true) {
                this.search()
                this.alert_msg('success', 'Update Kanban Setup', result.message)
                $('.preloader').fadeOut()
              } else {
                this.search()
                this.alert_msg('warning', 'Update Kanban Setup', result.message)
                // eslint-disable-next-line no-undef
                $('.preloader').fadeOut()
              }
            },
            error => {
              this.search()
              this.alert_msg('error', 'Update Kanban Setup', error.message)
              // eslint-disable-next-line no-undef
              $('.preloader').fadeOut()
            }
          )
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/kbsetup_edit_modal.vue